<template>
  <v-ons-list-item
    modifier="longdivider"
    @click="showDetail"
  >
    <div class="center">
      <section class="destination-outline">
        <h1 class="destination-outline-title">{{ spot.name }}</h1>
        <p>{{ areaName }}</p>
        <p>{{ categoryName }}</p>
        <p>
          人気度
          <span
            v-for="n in 5"
            :key="n"
            :class="['destination-outline-star', {'on' : n <= popularityDegree}]"
          >★</span>
        </p>
        <p>
          混雑度
          <span v-if="isOpenSpot">{{ congestionDegree }}%</span>
          <span
            v-else
            :class="isAvailable ? 'available' : 'unavailable'"
          >{{ avaiableText }}
          </span>
        </p>
      </section>
    </div>
    <div class="right">
      <img
        :src="image"
        width="130px"
        class="image-thumb"
      >
    </div>
  </v-ons-list-item>
</template>

<script>
import config from '@/config.js';

const noimage = require('@/assets/images/noimage.svg');

export default {
  props: {
    spot: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    floorId: ({ spot }) => spot.floor.id,
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    image: ({ spot }) => spot.image.thumb.url || noimage,
    isOpenSpot: ({ spot }) => spot.type === 'Spot::OpenSpot',
    spotState: ({ spot }) => spot.spotState,
    numberObSeats: ({ spot }) => spot.numberOfSeats,
    numberOfPerson: ({ spotState }) => (spotState ? Number(spotState.numberOfPerson) : 0),
    isAvailable: (vm) => !vm.isOpenSpot && vm.numberOfPerson === 0,
    areaName: (vm) => vm.$store.getters['area/buildingAndFloorNameByFloorId'](vm.spot.floor.id),
    categoryName() {
      const category = config.destination.spot.spotTypes.find((spotType) => spotType.key === this.spot.type);
      if (!category) return '';
      return category.name;
    },
    popularityDegree: ({ spotState }) => spotState.popularityDegree || 0,
    congestionDegree: ({ spotState }) => spotState.congestionDegree || 0,
    avaiableText: ({ isAvailable }) => (isAvailable ? '利用可能' : '利用不可'),
  },
  methods: {
    showDetail() {
      // NOTE: 詳細画面では遷移させない
      if (!this.$el.hasAttribute('tappable')) return;

      this.$store.commit('current/setDestination', this.spot);
      this.$store.dispatch('searchResult/getSpot', this.spot.id);
      this.$store.dispatch('destinationDetail/show');

      // NOTE: 別の建物にある場合は移動する
      if (this.currentFloorId !== this.floorId) this.$store.commit('current/setFloorId', this.floorId);

      // NOTE: 人気スポットから来た時(=テキスト検索の結果がない時)はスポット名を検索バーに入れる
      if (this.$store.state.searchResult.destinations.length > 0) return;

      this.$store.commit('destinationSearchForm/setSearchWord', this.spot.name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// spot.vue?2ac0d1fb